import React, { useContext } from "react";
import BugReportEnhancerPage from "../../output-components/bug-report-enhancer/BugReportEnhancerPage";
import { useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { BugReportDataContext } from "../BugReportPage";

const BugReportOutputPage = () => {
  const location = useLocation();
  const { bugReportData, enhancedBugReport } = location.state || {
    bugReportData: {},
    enhancedBugReport: {},
  };
  const { setBugReportData, setEnhancedBugReportData } = useContext(BugReportDataContext);
  setBugReportData(bugReportData);
  setEnhancedBugReportData(enhancedBugReport);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100vh",
        overflow: "hidden",
        width: "100%",
        backgroundColor: "#f6f3f2",
      }}
    >

      <Box
        className="bug-report-container"
        sx={{
          bgcolor: "#F6F3F2",
          p: 2,
          // width: "600px",
          pb: 5,
          overflow: "hidden",
        }}
      >


        <BugReportEnhancerPage
          bugReportData={bugReportData}
          enhancedBugReport={enhancedBugReport}
        />

        <Box
          component="footer"
          sx={{
            width: "100%",
            // maxWidth: "601px",
            backgroundColor: "#f6f3f2",
            textAlign: "center",
            paddingX: "5px",
            position: "fixed",
            bottom: "0",
            zIndex: "99"
          }}
        >
          <Typography variant="caption" color="textSecondary">
            Use QMentisAI™ with human supervision, as with all generative AI tools.
          </Typography>
        </Box>
      </Box>
    </div>
  );
};

export default BugReportOutputPage;
